import { Resume, ResumeProps } from 'src/widgets/resume';

export default (props: ResumeProps) => <Resume {...props} />;
